exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".diagram {\r\n  transform: translate(0,0) scale(1);\r\n  height: 100%;\r\n}\r\n.diagramContainer {\r\n  overflow: hidden;\r\n  background: #fafafa;\r\n  width: 100%;\r\n  flex-grow: 1;\r\n}\r\nsvg.jtk-dragging path {\r\n  stroke-opacity: 0.53;\r\n  stroke-dasharray: 4 4;\r\n}", ""]);

// exports
